import { FormControlLabel, Radio, RadioGroup as MUIRadioGroup } from '@mui/material'
import { useFormikContext } from 'formik'
import { useDispatch } from 'react-redux'
import { registrationSliceActions } from '../../store/features/registration'

interface iRadioGroupProps{
    name: string
    labels: {value:string,text:string | JSX.Element}[]
}

export default function RadioGroup({name, labels}:iRadioGroupProps) {

    const {setFieldValue, setFieldTouched, values,} = useFormikContext<any>()
    const dispatch = useDispatch()

    return (
        <MUIRadioGroup
            defaultValue={values[name]}
            name={name}
            onChange={({target})=>{
                setFieldValue(name, target.value)
                dispatch(dispatch(registrationSliceActions.setSubInfo(target.value)))
            }}
            onBlur={()=>{setFieldTouched(name)}}
        >
            {
                labels.map((label, index)=>(
                    <FormControlLabel 
                        value={label.value} 
                        control={<Radio />} 
                        label={label.text} 
                        key={index}
                    />
                ))
            }
            
        </MUIRadioGroup>
    )
}
